import RoleForm from "./RoleForm";
import { useEffect, useState } from "react";
import { useGetRoleByIdQuery } from "./rolesApi";
import { skipToken } from "@reduxjs/toolkit/query";

const CreateRole = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/" },
        { content: "Users", url: "/roles" },
        { content: "Add Role", url: "/roles/create" },
    ]);

    const roleId = localStorage.getItem("roleId")
    const roleByIdQuery = useGetRoleByIdQuery(roleId ?? skipToken);
    const [roleData, setRoleData] = useState<any>({});

    useEffect(() => {
        if (roleByIdQuery?.data) {
            const { name, authorityLevel } = roleByIdQuery.data;
            setRoleData({ name: name + " Copy", authorityLevel });
        }
    }, [roleByIdQuery?.data]);

    return (
        <>
            <RoleForm crumbs={crumbs} title={"Add Role"} btnText={"Create"} roleId={roleId}
                roleByIdQuery={roleByIdQuery} setRoleData={setRoleData} roleData={roleData}/>
        </>
    )
}
export default CreateRole;